import React, { FC, useState } from "react";
import {
  IonButton,
  IonSpinner,
  IonSelectOption,
  IonSelect
} from "@ionic/react";

interface IProps {
    handleRequest:(month:number,year:number,numMonths?:number)=>void
    loading:boolean,
    monthsRequired?:boolean
};

const MonthYearRequestBtn:FC<IProps> = ({handleRequest,loading, monthsRequired=false}) => {
    const today = new Date();
    today.setMonth(today.getMonth() - 1);
    const [month, setMonth] = useState(today.getMonth() + 1);
    const [year, setYear] = useState(today.getFullYear());
    const yr = new Date().getFullYear();
    const years = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    const [numMonths, setNumMonths] = useState(3)

    return <div>
        <div style={{ width: "100%", textAlign: "center", padding: "1rem" }}>
                          Enter Month and Year to Generate and Download Report.
                        </div>
                        {/* <IonDatetime presentation="month-year"></IonDatetime> */}
                        { monthsRequired ? <div>
                          <IonSelect value={numMonths} label="Number of Months" interface="popover"  onIonChange={(e)=> setNumMonths(e.detail.value)}>
                          <IonSelectOption value={1}>1</IonSelectOption>
                          <IonSelectOption value={2}>2</IonSelectOption>
                          <IonSelectOption value={3}>3</IonSelectOption>
                          <IonSelectOption value={4}>4</IonSelectOption>
                          <IonSelectOption value={5}>5</IonSelectOption>
                          <IonSelectOption value={6}>6</IonSelectOption>
                          <IonSelectOption value={7}>7</IonSelectOption>
                          <IonSelectOption value={8}>8</IonSelectOption>
                          <IonSelectOption value={9}>9</IonSelectOption>
                          <IonSelectOption value={10}>10</IonSelectOption>
                          <IonSelectOption value={11}>11</IonSelectOption>
                          <IonSelectOption value={12}>12</IonSelectOption>
                        </IonSelect>
                        </div> : null }
                        <div>
                          <IonSelect
                            label="Month"
                            interface="popover"
                            value={month}
                            placeholder="Month"
                            onIonChange={(e) => {
                              setMonth(e.detail.value!);
                            }}
                          >
                            <IonSelectOption value={1}>1 - January</IonSelectOption>
                            <IonSelectOption value={2}>2 - February</IonSelectOption>
                            <IonSelectOption value={3}>3 - March</IonSelectOption>
                            <IonSelectOption value={4}>4 - April</IonSelectOption>
                            <IonSelectOption value={5}>5 - May</IonSelectOption>
                            <IonSelectOption value={6}>6 - June</IonSelectOption>
                            <IonSelectOption value={7}>7 - July</IonSelectOption>
                            <IonSelectOption value={8}>8 - August</IonSelectOption>
                            <IonSelectOption value={9}>9 - September</IonSelectOption>
                            <IonSelectOption value={10}>10 - October</IonSelectOption>
                            <IonSelectOption value={11}>11 - November</IonSelectOption>
                            <IonSelectOption value={12}>12 - December</IonSelectOption>
                          </IonSelect>
                          <IonSelect
                            label="Year"
                            interface="popover"
                            placeholder="Year"
                            value={year}
                            onIonChange={(e) => {
                              setYear(e.detail.value!);
                            }}
                          >
                            {years.map((i: number) => (
                              <IonSelectOption key={i} value={yr - i}>
                                {yr - i}
                              </IonSelectOption>
                            ))}
                          </IonSelect>
                        </div>
              <IonButton
                fill="solid"
                color="primary"
                size="small"
                expand="block"
                onClick={() => monthsRequired ? handleRequest(month,year, numMonths) : handleRequest(month,year)}
                >
                  {loading ? <IonSpinner /> : "Download"}
              </IonButton>
    </div>
};

export default MonthYearRequestBtn;